import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetRevenueByMonthQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import { useFilters } from '../../context/filters.context';

export const RevenueByMonthCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetRevenueByMonthQuery({
    ...transformedFilters,
  });

  return <ByDateCard data={data} variant={ByDateCardVariantEnum.Revenue} />;
};
